<template>
  <el-dialog :title="!id ? '新增' : '编辑'" :visible.sync="show" :append-to-body="true" :close-on-click-modal="false" width="600px">
    <!-- 内容区域 -->
    <div class="dialog-wrap" style="height: 280px">
      <FormView ref="vForm" :labels="fromLabels" :formConfig="{ labelWidth: '150px' }" :slotIdxList="[4]" style="height: 100%">
        <template #form-items="{ idx, form }">
          <el-col v-if="idx == 4">
            <el-form-item>
              <el-checkbox v-model="form.setDefault">设为默认邮寄地址</el-checkbox>
            </el-form-item>
          </el-col>
        </template>
      </FormView>
    </div>
    <span slot="footer">
      <el-button plain @click="show = false">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="btnloadSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formAddressInfo } from '@/configs/forms'
export default {
  data() {
    return {
      btnloadSubmit: false,
      id: null,
      show: false,
      fromLabels: formAddressInfo,
      detail: {},
      comeFrom: ''
    }
  },
  methods: {
    // 数据清空
    clear() {
      this.id = null
      this.detail = {}
    },
    open(obj, from) {
      this.clear()
      if (obj && obj.addressId) {
        // 编辑
        const { addressId, name, phone, province, city, area, addressDefail, isDefault } = obj
        this.id = obj.addressId
        this.detail = { addressId, name, phone, province, city, area, addressDefail, isDefault, setDefault: isDefault == '是' ? true : false }
      } else {
        // 添加
        this.detail = {
          isDefault: '否',
          setDefault: false
        }
        if (from) {
          this.comeFrom = from
        }
      }
      this.show = true
      this.$nextTick(() => {
        this.$refs.vForm.fillData(this.detail)
      })
    },
    // 提交
    async submit() {
      // 结果更新
      const params = await this.$refs.vForm.getForm()

      params.isDefault = params.setDefault ? '是' : '否'
      this.btnloadSubmit = true
      if (this.id) {
        // 编辑
        const res = await this.$api.EditAddressInfo(params).finally(() => {
          this.btnloadSubmit = false
        })
        this.$message.success('编辑成功')
      } else {
        // 添加
        const res = await this.$api.AddAddressInfo(params).finally(() => {
          this.btnloadSubmit = false
        })
        this.$message.success('发布成功')
      }
      this.$emit('submit', {refName: 'addressRef', from: this.comeFrom})
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrap {
  ::v-deep .el-form {
    height: 100%;
    .el-row {
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>